import { Box, Grid, Modal } from '@mui/material'

import EQServiceCaregiver from '../../services/EQServiceCaregiver'
import EQState from '../../services/EQState'
import React from 'react'
import Utils from '../../libs/Utils'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 400,
  width: '80%',
  bgcolor: '#ffe371',
  border: '0',
  boxShadow: 24,
  p: 2,
  alignContent: 'center',
  justifyContent: 'center',
  alignItems: 'center',
}

export default class EQConfirmModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  closeModal() {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  cancelOperation() {
    this.closeModal()
  }

  actuallyDoOperation() {
    EQServiceCaregiver.accettaAppuntamento(this.props.selectedEvent)
      .then((y) => {
        EQServiceCaregiver.getAppuntamento(
          this.props.selectedEvent.idCalendario
        ).then((x) => {
          Utils.refill(this.props.selectedEvent, x.data)
          this.closeModal()
          // Refresh della pagina
          setTimeout(() => {
            EQState.change(EQState.CaregiverHome, {})
          }, 500)
        })
      })
      .finally((x) => {
        // In caso di errore ricarichiamo l'evento a calendario
        EQServiceCaregiver.getAppuntamento(
          this.props.selectedEvent.idCalendario
        ).then((x) => {
          Utils.refill(this.props.selectedEvent, x.data)
          this.closeModal()
          // Refresh della pagina
          setTimeout(() => {
            EQState.change(EQState.CaregiverHome, {})
          }, 500)
        })
      })
  }

  render() {
    return (
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={style}
          className="text-black  w-50">
          <Box
            mt={0}
            p={0}
            pt={2}
            pb={2}>
            <div className="textCenter playFair app-text modal-title">
              <b>Sei sicuro di voler accettare la prenotazione?</b>
            </div>

            <Grid
              container
              mt={0}
              mb={2}
              className="flex-row-center gap-15">
              <Grid
                item
                xs={2}>
                <a
                  className="buttonLink white lnkForward bg-red full-rounded"
                  onClick={() => this.cancelOperation()}>
                  NO
                </a>
              </Grid>
              <Grid
                item
                xs={2}>
                <a
                  className="buttonLink white lnkForward bg-green full-rounded"
                  style={{ minWidth: '54.78px' }}
                  onClick={() => this.actuallyDoOperation()}>
                  {' '}
                  SI{' '}
                </a>
              </Grid>
            </Grid>

            <Box mt={6}>
              <div className="textCenter playFair app-text italic">
                Una volta confermata l'operazione verrà inviata una notifica al
                cliente
              </div>
            </Box>
          </Box>
        </Box>
      </Modal>
    )
  }
}
